module.exports = __webpack_public_path__ + "img/73.62654fa.png";